import React from 'react';
import { useParams } from 'react-router-dom';
import ResetPassword from './ResetPassword'; // Your original class component

const ResetPasswordWrapper = (props) => {
  const { token } = useParams();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ResetPassword {...props} token={token} />;
};

export default ResetPasswordWrapper;